export const TAB_ITEMS = [
  {
    title: 'Inicio',
    path: '/',
    icon: '/lordicons/home.json', // home
  },
  {
    title: 'Busca',
    path: '/search',
    icon: '/lordicons/search.json', // search
  },
  {
    title: 'Pedidos',
    path: '/orders',
    icon: '/lordicons/orders.json', //
  },
  {
    title: 'Perfil',
    path: '/profile',
    icon: '/lordicons/profile.json', // user profile
  },
];
